import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { formatViews } from "@/utils/format";

export default function Hero() {
  const featured = articles[0];
  const side = articles.slice(1, 5);

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 pb-4 pt-8 md:px-6 md:pt-10">
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <article className="relative col-span-1 overflow-hidden rounded-lg lg:col-span-2">
            <Link to={`/article/${featured.slug}`} className="group block cursor-pointer">
              <div className="relative h-[300px] w-full overflow-hidden bg-foreground-800 md:h-[420px]">
                <img
                  src={featured.cover}
                  alt={featured.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                  <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                    <i className="ri-fire-fill" aria-hidden="true" />
                    今日头条
                  </span>
                  <h1 className="max-w-3xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                    {featured.title}
                  </h1>
                  <p className="mt-3 hidden max-w-2xl text-sm leading-6 text-background-200 sm:block">
                    {featured.excerpt}
                  </p>
                  <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-background-300">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-user-3-line" aria-hidden="true" />
                      {featured.author}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-eye-line" aria-hidden="true" />
                      {formatViews(featured.views)} 阅读
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-time-line" aria-hidden="true" />
                      {featured.readTime}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </article>

          <div className="flex flex-col rounded-lg border border-background-200/80 bg-background-100/60 p-4">
            <h2 className="mb-1 flex items-center gap-2 font-heading text-sm font-bold text-foreground-900">
              <i className="ri-flashlight-fill text-accent-500" aria-hidden="true" />
              正在发酵
            </h2>
            <div className="flex flex-1 flex-col">
              {side.map((a, idx) => (
                <Link
                  key={a.slug}
                  to={`/article/${a.slug}`}
                  className="group flex cursor-pointer items-start gap-3 border-b border-background-200/70 py-3 last:border-0"
                >
                  <span
                    className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded font-heading text-xs font-bold ${
                      idx === 0
                        ? "bg-accent-500 text-foreground-950"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {idx + 1}
                  </span>
                  <div className="min-w-0">
                    <h3 className="line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                      {a.title}
                    </h3>
                    <span className="mt-1 block text-xs text-foreground-500">
                      {a.categoryName} · {formatViews(a.views)} 阅读
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}